import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getInstitutions, getMedics, searchHospital, searchMedics } from '../../actions/systemsAction';

export const MedicHospitalListComponent = ({viewType = 'Medic', itemselected, setItemselected}) => {

    const dispatch = useDispatch();
    const [searchItem, setsearchItem] = useState("");
    const [items, setItems] = useState(null);
    const institutions = useSelector(state => state.systems.getInstitutions);
    const Medics = useSelector(state => state.systems.getMedics);
    const searchMedicos = useSelector(state => state.systems.searchMedics);
    const searchHospitals = useSelector(state => state.systems.searchHospitals);


    const handleSelectItemCardClick = (item) => {
        setItemselected(item);
    }

    useEffect(() => {
        setsearchItem('');
    }, [viewType])

    useEffect(() => {
        dispatch( getMedics() );
        dispatch( getInstitutions() );
    }, [])

    useEffect(() => {
        if(institutions && searchItem.trim().length === 0 && viewType === 'Hospital'){
            setItems(institutions)
        }else if(searchHospitals && searchItem.trim().length !== 0 && viewType === 'Hospital'){
            setItems(searchHospitals)
        }
        if(Medics && searchItem.trim().length === 0 && viewType === 'Medic'){
            setItems(Medics)
        }else if(searchMedicos && searchItem.trim().length !== 0 && viewType === 'Medic'){
            setItems(searchMedicos)
        }
    }, [institutions, Medics, searchItem, viewType])


    useEffect(() => {
        if(searchItem.trim().length !== 0 && viewType === 'Medic'){
            dispatch(searchMedics( searchItem));
        }
        if(searchItem.trim().length !== 0 && viewType === 'Hospital'){
            dispatch(searchHospital( searchItem));
        }
    }, [searchItem]);


    const handlesearchItem = (e) => {
            e.preventDefault();
            if(viewType === 'Medic' ){
                dispatch(searchMedics( searchItem ));
            }
            if(viewType === 'Hospital' ){
                dispatch(searchHospital( searchItem ));
            }
    }


    

    return (
        <>
            <form className="medic_hospital_list_component_container_search"
                onSubmit={handlesearchItem}>
                <input type="text"
                    autoComplete="off"
                    name="searchItem"
                    value={searchItem}
                    onChange={({ target }) => setsearchItem(target.value)}
                    placeholder='Buscar...'
                    className="medic_hospital_list_component_search"
                />
            </form>

            <div className="medic_hospital_list_component_container_cards">
                {
                    items && items.length > 0 &&
                        items.map( el => (
                            <div    className={ (   itemselected && viewType === 'Medic' && el.medicCode === itemselected.medicCode 
                                                    || itemselected && viewType === 'Hospital' && el.hospitalCode === itemselected.hospitalCode    
                                                ) 
                                                ? 'medic_hospital_list_component_container_card_selected' 
                                                : 'medic_hospital_list_component_container_card' }
                                    onClick={() => handleSelectItemCardClick(el)} 
                                    key={el.userID}
                            >
                                <div className="medic_hospital_list_component_card_container_info">
                                    {
                                        viewType === 'Medic' &&
                                        <>
                                            <span className="medic_hospital_list_component_card_container_info_name">
                                                Nombre: { el.name && `${el.name} ` } 
                                                { el.secondName && `${el.secondName} ` } 
                                                { el.firstLastname && `${el.firstLastname} `} 
                                                { el.secondLastname && `${el.secondLastname}` }
                                            </span>
                                            <span className="medic_hospital_list_component_card_container_info_mail">
                                                Correo: { el.email && `${el.email} ` } 
                                            </span>
                                        </>
                                    }
                                    {
                                        viewType === 'Hospital' && 
                                            <>
                                                <span className="medic_hospital_list_component_card_container_info_name">
                                                    Nombre: { el.name && `${el.name} ` } 
                                                </span>
                                                <span className="medic_hospital_list_component_card_container_info_mail">
                                                    Ciudad: { el.city && `${el.city} ` } 
                                                </span>
                                            </>
                                    }
                                </div>
                                <div className="medic_hospital_list_component_card_container_arrow">
                                    <span className='arrowRight'></span>
                                </div>

                            </div>
                        ))
                }
            </div>

    </>
    )
}


MedicHospitalListComponent.propTypes = {
    viewType: PropTypes.any,
    itemselected: PropTypes.any,
    setItemselected: PropTypes.any,
}
